/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSuccessDto } from '../../models/lexplus-success-dto';
import { LexplusUpdateBenutzerAktivDto } from '../../models/lexplus-update-benutzer-aktiv-dto';

export interface BenutzerverwaltungControllerSetAktivV1$Params {
  id: string;
      body: LexplusUpdateBenutzerAktivDto
}

export function benutzerverwaltungControllerSetAktivV1(http: HttpClient, rootUrl: string, params: BenutzerverwaltungControllerSetAktivV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, benutzerverwaltungControllerSetAktivV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

benutzerverwaltungControllerSetAktivV1.PATH = '/v1/benutzerverwaltung/{id}/aktiv';
